import {HttpRequest} from "../utils/httpRequest";

let Order = {
    /**
     * 获取数据列表
     * @param datas
     * @returns {*}
     */
    getOrderList(datas) {
        return HttpRequest.getRequest({
            url: '/edu/order/list',
            method: 'get',
            data: datas
        });
    },
    /**
     * 获取客户列表
     * @returns {*}
     */
    getCusList() {
        return HttpRequest.getRequest({
            url: '/edu/customer/all',
            method: 'get'
        });
    },
    /**
     * 获取客户信息
     * @param id
     */
    getCusInfo(id) {
        return HttpRequest.getRequest({
            url: '/edu/customer/info/' + id,
            method: 'get'
        });
    },
    /**
     * 获取用户列表
     * @returns {*}
     */
    getUserList() {
        return HttpRequest.getRequest({
            url: '/edu/user/total',
            method: 'get'
        });
    },
    /**
     * 获取数据信息
     * @param id
     * @returns {*}
     */
    getOrderInfo(id) {
        return HttpRequest.getRequest({
            url: '/edu/order/info/' + id,
            method: 'get'
        });
    },
    /**
     * 添加或修改
     * @param type
     * @param datas
     * @returns {*}
     */
    addOrUpdateOrder(type, datas) {
        return HttpRequest.getRequest({
            url: '/edu/order/' + type,
            method: 'post',
            data: datas
        });
    },
    /**
     * 删除
     * @param ids
     * @returns {*}
     */
    deleteOrder(ids) {
        return HttpRequest.getRequest({
            url: '/edu/order/delete',
            method: 'get',
            data: ids
        });
    }
};
export {Order}
